<template>
  <SpaceOpener>
    <FileManager show_add_menu="true" title="我的网盘" :space="space" />
  </SpaceOpener>
</template>

<script>
import FileManager from '../components/file-manager.vue'
import SpaceOpener from '../components/space-opener.vue'

export default {
  name: 'FilesPage',
  props: [],
  components: {
    FileManager,
    SpaceOpener,
  },
  data: function () {
    return {
    };
  },
  computed: {
    space() {
      return this.$store.state.space;
    },
  },
  methods: {
  },
  async mounted() {
  },
}
</script>

<style scoped>
</style>
